var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteamsDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "microsoftteamsDark_svg__original_copy",
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".microsoftteamsDark_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "microsoftteamsDark_svg__Path_11_",
  d: "M19.5 3.2c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3",
  className: "microsoftteamsDark_svg__st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2 10.1h-3.9v7.2c0 .9-.8 1.6-1.7 1.6H7.1c.7 2.1 2.7 3.7 5.1 3.9 3.4.2 6.2-2.3 6.2-5.5v-6.1c0-.6-.5-1.1-1.2-1.1M21.8 10.1h-3.1c.2.3.4.7.4 1.1v6.1c0 .7-.1 1.4-.3 2 .2.1.5.1.7.1 1.9 0 3.5-1.6 3.5-3.5v-4.6c0-.7-.5-1.2-1.2-1.2",
  className: "microsoftteamsDark_svg__st0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6 7.8H2c-.5 0-1 .4-1 .9v8.7c0 .5.4.9 1 .9h9.6c.5 0 1-.4 1-.9V8.7c0-.5-.5-.9-1-.9m-2.5 3.3H7.4v4.8H6.2v-4.8H4.5v-1h4.6z",
  className: "microsoftteamsDark_svg__st0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 3.7c-.6-1-1.8-1.7-3-1.7s-2.4.7-3 1.7C9 4.8 9 6 9.5 7h2.1c1 0 1.7.7 1.7 1.6v.2c.9-.2 1.8-.8 2.3-1.6.6-1.1.6-2.4 0-3.5",
  className: "microsoftteamsDark_svg__st0"
})));
export { SvgMicrosoftteamsDark as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteamsDark.240a16f7.svg";